import {
  Card,
  Header,
  Image,
  Item,
  ItemContent,
  ItemDescription,
  ItemExtra,
  ItemHeader,
  ItemImage
} from "semantic-ui-react"
import React, { useState } from "react"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { updateActiveVehicle } from "../../../../v1/actions/vehicles"
import store from "../../../../shared_component/utils/configureStore"
import placeholderCarImg from "../../../../images/placeholder_car.svg"
import { routerPaths } from "../../../../v1/constants/paths"
import { withRouter } from "react-router-dom"
import Notifications from "../../../../v1/components/Notifications"
import {
  gaJSON,
  serviceSelectedEvents,
  trackFirebaseAnalytics
} from "../../../../shared_component/utils/googleAnalyticsHelpers"
import LeftArrowIcon from "../../../../images/left_arrow_icon.svg"
import InfoIcon from "../../../../images/info-Icon.svg"

const SelectVehicle = ({
  t,
  history,
  user,
  handleSearchAgain,
  activeVehicle,
  asModal,
  activeOrder,
  closeModalHandler
}) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const isOilChangeService = localStorage.getItem("isOilChangeService") === "true" || false
  const isComparePriceFlow = localStorage.getItem("isComparePriceFlow") === "true" || false
  const vehicles = user.vehicles || []

  const handleToggleSelectVehicle = async () => {
    if (handleSearchAgain) {
      handleSearchAgain()
    } else {
      history.push(routerPaths.addVehicle)
    }
  }

  const handleVehicleSelect = async (vehicle) => {
    setIsSubmitting(true)
    try {
      await store.dispatch(await updateActiveVehicle(vehicle.id))
      setIsSubmitting(false)
      if (asModal) {
        closeModalHandler()
        return
      }

      if (isComparePriceFlow) {
        history.push({
          pathname: routerPaths.reviewAppointment
        })
      } else if (isOilChangeService) {
        history.push({
          pathname: routerPaths.shopSelection
        })
      } else {
        history.push({
          pathname: routerPaths.selectService
        })
      }
    } catch (e) {
      trackFirebaseAnalytics({
        event: gaJSON.EtoB_vehicle_submit_error
      })
      store.dispatch(
        Notifications.error({
          title: t("errorLbl"),
          message: e.toString(),
          position: "tr",
          autoDismiss: 5,
          action: {
            label: "Dismiss"
          }
        })
      )
      setIsSubmitting(false)
    }
  }

  if (vehicles.length === 0) {
    history.push({ pathname: routerPaths.addVehicle })
  }

  return (
    <Card className="select-vehicle-card" raised={true}>
      <Header as="h3">{t("Select a vehicle")}</Header>
      {(activeOrder?.vehicle_id || 0) > 0 && (
        <Card fluid className="default-vehicle-info">
          <Image src={InfoIcon} />
          <span>
            {" "}
            <b>
              {t(
                `Your ${activeOrder?.vehicle?.year || ""} ${activeOrder?.vehicle?.make || ""} ${
                  activeOrder?.vehicle?.model || ""
                } has an active appointment.`
              )}
            </b>{" "}
            {t("Select other vehicles or add new vehicle to browse services.")}
          </span>
        </Card>
      )}

      {vehicles.map((vehicle) => {
        return (
          <Item
            onClick={() => handleVehicleSelect(vehicle)}
            key={vehicle.id}
            className={`${vehicle.id === activeVehicle.id ? "default-vehicle" : ""} ${
              (activeOrder?.vehicle_id || 0) === vehicle.id ? "disable" : ""
            }`}
          >
            <div className="vehicle-info">
              <ItemImage
                className="vehicle-image"
                size="tiny"
                src={vehicle.dashboard_url || placeholderCarImg}
              />
              <ItemContent>
                <ItemHeader>
                  {vehicle.year} {vehicle.make} {vehicle.model}
                </ItemHeader>
                <ItemDescription>
                  {(vehicle.predicted_current_odometer_config || {}).display_quantity || ""} mi{" "}
                </ItemDescription>
              </ItemContent>
            </div>
            <ItemExtra>
              {vehicle.id == activeVehicle.id && (
                <span className="default_vehicle">&#x2022; Primary</span>
              )}
              <Image className="left-arrow-icon" src={LeftArrowIcon} />
            </ItemExtra>
          </Item>
        )
      })}
      <p className="link-text" onClick={handleToggleSelectVehicle}>
        {t("+ Add new vehicle")}
      </p>
    </Card>
  )
}

function mapStateToProps(state, props) {
  let user = state.user || {}
  let activeVehicle = (user.vehicles || []).find((v) => v.id === user.activeVehicleId) || {}
  let activeOrder =
    activeVehicle &&
    activeVehicle.id &&
    (user.active_orders || []).find((o) => o.vehicle_id === activeVehicle.id)

  return {
    user: user,
    activeVehicle: activeVehicle,
    activeOrder: activeOrder
  }
}

export default withRouter(
  connect(mapStateToProps)(withTranslation("vehicleDetails")(SelectVehicle))
)
